import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
function VideoGallery() {
    return (
        <>
            <Header />
            <Breadcrumb title="Video Gallery " midBreadcrumb="Gallery" mainBreadcrumb="Video Gallery" ></Breadcrumb>
            <div className='inner-page'>
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-sm-10 col-xs-12">
                                    <h2 class="mainhead">Video Gallery</h2>
                                </div>
                                <div class="col-sm-2 col-xs-12">
                                    <div class="dynamicdiv  video-end">
                                        <div class="year-selection">
                                            <select id="ddlYear"><option value="0">All Years</option></select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="p-3"></div>
                                    <div id="showTwo" class="myDiv selected_year">
                                        <div class="row gy-3" id="video-gallery">
                                            <div class="col-lg-6 col-xl-4">
                                                <div class="video-thumbnail">
                                                    <div class="image-wrapper">
                                                        <img class="img-thumbline"
                                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/vgal.jpg"
                                                            alt="Mata Mariam Jan Seva Vidyalay" />
                                                    </div>
                                                    <div class="video-thumbnail-play">
                                                        <a href="#" class="video-thumbnail-play-btn">
                                                            <i class="bi bi-play-fill"></i>
                                                        </a>
                                                    </div>
                                                    <div class="video-list_content">
                                                        <p class="video-list_text">07 Jan 2024</p>
                                                        <h3 class="video-list_title">Video Title</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-xl-4">
                                                <div class="video-thumbnail">
                                                    <div class="image-wrapper">
                                                        <img class="img-thumbline"
                                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/vgal.jpg"
                                                            alt="Mata Mariam Jan Seva Vidyalay" />
                                                    </div>
                                                    <div class="video-thumbnail-play">
                                                        <a href="#" class="video-thumbnail-play-btn">
                                                            <i class="bi bi-play-fill"></i>
                                                        </a>
                                                    </div>
                                                    <div class="video-list_content">
                                                        <p class="video-list_text">07 Jan 2024</p>
                                                        <h3 class="video-list_title">Video Title</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-xl-4">
                                                <div class="video-thumbnail">
                                                    <div class="image-wrapper">
                                                        <img class="img-thumbline"
                                                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/vgal.jpg"
                                                            alt="Mata Mariam Jan Seva Vidyalay" />
                                                    </div>
                                                    <div class="video-thumbnail-play">
                                                        <a href="#" class="video-thumbnail-play-btn">
                                                            <i class="bi bi-play-fill"></i>
                                                        </a>
                                                    </div>
                                                    <div class="video-list_content">
                                                        <p class="video-list_text">07 Jan 2024</p>
                                                        <h3 class="video-list_title">Video Title</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default VideoGallery